import { ReactNode, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CompaniesRepository from '@/application/repositories/CompaniesRepository';
import { useAppStore } from '@/store';

import logoDefault from '@/assets/img/primepass-logo.svg';

import Header from './Header';
import Main from './Main';
import Footer from './Footer';
import SubHeader from './SubHeader';

type LayoutProps = {
  children: ReactNode;
}

const companiesRepository = new CompaniesRepository();

const Layout = ({ children }: LayoutProps) => {
  const { setAppStore, appStore } = useAppStore();
  const { companiesSlug } = useParams();

  useEffect(() => {
    (async () => {
      if (!companiesSlug) {
        return;
      }
      const { logo, banner, textContent, scriptContent } = await companiesRepository.getBySlug(companiesSlug as string);

      setAppStore({ logo, banner, regulation: textContent, scriptContent});
    })();
  }, []);

  return (
    <div className="app-container">
      <Header logo={logoDefault} />
      {appStore.logo && (
        <SubHeader logo={appStore.logo} text="Benefício exclusivo:" />
      )}
      <Main style={{
        marginTop: appStore.logo ? '30px' : '120px'
      }} >{children}</Main>
      <Footer />
    </div>
  )
};

export default Layout;